<template>
    <div id="paymentday">
    <div class="table-box">
        <div class="table-head">
          <div style="margin-left:13px;">
            <i class="iconfont icon-liebiao" style="color:#666666"></i> 增值服务
          </div>
          <!-- <el-button class="add-btn" size="small" @click="centerDialogVisible = true">添加</el-button> -->
        </div>
        <el-card class="box-card service-main">
            <div class="my-service">
            <h4>已开通的服务</h4>
            <div v-if="myservice && myservice.length > 0">
              <el-tag v-for="item in myservice" :key="item">{{item}}</el-tag>
            </div>
            <span class="no-service" v-else>
                尚未开通任何服务!
            </span>
            </div>
            <el-divider></el-divider>
            <el-alert :title="tip_title" :type="tip_type"></el-alert>
            <div class="service-list" v-for="tags in cities" :label="tags.value"  :key="tags.value">
                
                <h4><i class="el-icon-caret-right ico-mm"></i>{{tags.name }}</h4>
                <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                <span>   
                <el-checkbox v-for="city in tags.children" :label="city.value"  :key="city.value">{{city.name}}</el-checkbox>
                </span> 
                </el-checkbox-group> 
            </div>
           
            <el-divider></el-divider>
            <el-button class="apply-btn" v-if="applyStatus == 1" type="primary" @click="applyInfo()">立即申请</el-button> 
            <el-button class="apply-btn" v-if="applyStatus == 0" type="primary" disabled="disabled">已提交申请</el-button> 
            <!-- <div class="apply-main">
                <h3></h3>


            </div> -->
        
  
        </el-card>
        
        <el-dialog
            title="增值服务申请"
            :visible.sync="centerDialogVisible"
            width="40%"
            center>
            <p>您要申请的服务项目包括：{{ checkedItem }},请确认无误后再确定提交！</p>
            <el-form status-icon  ref="ruleForm" label-width="100px" class="demo-ruleForm">
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="centerDialogVisible = false">取 消</el-button>
                <el-button type="primary" :disabled="isdisabled" @click="applyNow">确 定</el-button>
            </span>
        </el-dialog>
    </div>   
    </div>
</template>

<script>
const cityOptions = [
  {
    value:1,
    name:'消费者短信通知(0.09元/条)',
    children: [
        {
          value:'1',
          name:'消费者短信通知',
        },
        {
          value:'2',
          name:'商家短信通知',
        }  
      ]
  },
  {
    value:2,
    name:'代开发票',
    children: [
        {
          value:'3',
          name:'代开发票',
        }
      ]

  },{
    value:3,
    name:'批量导入(excel批量导入可免费导入1000件/店铺)',
    children: [
        {
          value:'4',
          name:'EXCEL批量导入',
        },
        {
          value:'5',
          name:'智能导入',
        }  
      ]
  }
];
export default {
    
    data () {
       return {
           serve: this.$store.state.serve,
           token: this.$cookies.get('shop_token'),
           centerDialogVisible: false,
           checkedCities: [],
           cities: cityOptions,
           applyCheck:[],
           strCheck:'',      //提交申请的服务id
           itemList:['消费者短信通知','商家短信通知','代开发票','EXCEL批量导入','智能导入'],
           checkedItem: '',
           applyStatus:1,       //当前申请服务,
           check_msg: '1',       //驳回原因
           tip_title: '开通增值服务？只需要勾选你要开通的服务项然后点立即申请即可！详情可咨询客服： 400-821-3401 ',
           tip_type: 'info',
           isdisabled: false, //防止多次提交
           myservice: false,
       }
    },
    created () {
        this.$store.state.shop_top = 3;
        this.$store.state.shop_left = "增值服务";
        this.itemStatus();
        
    },
    methods: {
        handleCheckedCitiesChange(value) {
           
            this.checkedCities = JSON.parse(JSON.stringify(value));

            let checkedCount = value.length;
            this.checkAll = checkedCount === this.cities.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
        },
        applyInfo(){
            
            let itemss = this.checkedCities;//Array.from(new Set(this.applyCheck));
             
            if(itemss.length <=0){
                this.$alerts.error("请选择你要申请的服务项目在进行提交！", this.$message);
                return false;
            }else{
                this.centerDialogVisible = true;
                var strs = "";
                for(var i=0;i<itemss.length;i++){
                   var j = itemss[i]-1; 
                   strs +="【"+this.itemList[j]+"】";
                }
                this.checkedItem = strs;
                this.strCheck = itemss.join(',');
            }
           
        },
        applyNow(){
            if(this.checkedItem.trim().length ==0){
                this.$alerts.error("请选择你要申请的服务项目在进行提交！", this.$message);
                return;
            }
            let that = this; 
            this.isdisabled = true;
            this.axios.get(this.serve + 'shop/service',{
                    params:{
                        token: this.token,
                        items:this.checkedItem,
                        str_item: this.strCheck
                    } 
                }).then(res => {
                    
                    let re = res.data;
                    if(re.status == 'success'){
                        this.$alerts.success("已提交申请！请耐心等待", this.$message);
                        this.centerDialogVisible = false;
                        this.itemStatus();
                    }else{
                        this.$message({
                            type: 'error',
                            message: re.msg
                        }); 
                    }
                    setTimeout(() => {
                        that.isdisabled = false;
                    }, 3000);
            })

        }, 
        itemStatus(){   //查看当前申请状态
             var that = this;
             this.axios.get(this.serve + 'shop/serviceStatus',{
                    params:{
                        token: this.token,
                    } 
                }).then(res => {
                    let re = res.data;
                  
                    if(re.status == 'success'){
                        
                        var data = re.data; 
                        if(data.shop_type == '2'){
                            that.cities.pop()
                          //that.cities = that.cities.shift();
                        }
                        if(data.item_status !=null && data.item_status.status == 0 ){
                            that.applyStatus = 0;
                            that.checkedCities = data.item_status.apply_item.split(',');
                        }else if(data.item_status !=null &&  data.item_status.status == 2){
                            that.applyStatus = 1;
                            that.checkedCities = data.item_status.apply_item.split(',');
                            that.tip_title = "平台审核信息:"+data.item_status.check_msg;
                            that.tip_type = 'error';
                        }
                        if(data.shop_item && data.shop_item.length >=1){
                             
                            var shop_item = data.shop_item;
                            var tagArr = [];
                            for(var i=0;i<shop_item.length;i++){
                                tagArr.push(this.itemList[shop_item[i]-1])
                            }
                            this.myservice = tagArr;
                            //that.checkedCities = data.shop_item;
                        }
                        
                    }else{
                        this.$message({
                            type: 'error',
                            message: re.msg
                        }); 
                    }
                })

        }
    }
}
</script>

<style lang="scss" scoped>
.table-box {
    margin-top: 19px;
    margin-bottom: 100px;
    .table-head {
      width: 1060px;
      height: 46px;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .table {
      width: 1062px;
    }
    .page-box {
      border-left: 1px solid rgba(221, 221, 221, 1);
      border-right: 1px solid rgba(221, 221, 221, 1);
      border-bottom: 1px solid rgba(221, 221, 221, 1);
      height: 60px;
      display: flex;
      justify-content: flex-end;
    }
  }
.service-main{  
    .service-list{
        margin-top:20px;
        h4{
            margin:10px 0;
        }
        .ico-mm{
            font-size:16px;
        }
        .el-checkbox-group{
            padding-left:16px;
        }
    }
    .my-service{
        margin: 5px;
        h4{
            text-align: center;
            margin-bottom: 10px;
        }
        .el-tag{
            margin-right:10px;
        }
        .no-service{
            font-size: 13px;
            color:orange;
        }
    }
    .apply-main{
        min-height: 300px;
    }
    .apply-btn{
        display: block;
        margin:0 auto;
    }
}    
</style>